/* eslint-disable prettier/prettier */
import localize from '../../localize';

export default {
  'taxonomies.Apex-areas': localize('refinementKommune')
    ? localize('refinementKommune')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
};
